import { isFQDN } from "validator";

/**
 * @param {boolean} optional - is optional if value is empty
 * @returns {(value: string) => boolean}
 */
export default function isDomainName(optional: boolean = false) {
  return (value: string) => {
    if (!value && optional) {
      return true;
    }

    // domain names must not begin with "www."
    return /^((?!www\.))/.test(value) && isFQDN(value);
  };
}
